import React, { Component } from 'react';
import { connect } from 'react-redux';
import './App.css';
import Layout from './components/Shared/Layout';
import Login from './components/Authentication/login';
import SignUp from './components/Authentication/signup';
import ForgotPassword from './components/Authentication/forgot-password';
import NotFound from './components/Authentication/404';
import UserMemberApplication from "./components/UserMembershipApplication/user-member-application";
import UserMemberApplicationList from "./components/UserMembershipApplication/user-member-application-list";
import UserMemberApplicationPayment from "./components/UserMembershipApplication/PaymentSuccess";
import UserMemberApplicationPaymentFailed from "./components/UserMembershipApplication/PaymentFailed";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ProtectedRoute from './routers/ProtectedRoute';
import { ROUTE_BASE_URL } from './api/common';
import UserMemberApplicationLogin from './components/UserMembershipApplication/user-member-application-login';
import UserMemberApplicationTracking from './components/UserMembershipApplication/user-member-application-tracking';
import UserMemberApplicationNotFound from './components/UserMembershipApplication/user-member-application-not-found';
import ChangePassword from './components/Authentication/change-password';
import UserMemberApplicationPreview from './components/UserMembershipApplication/user-member-application-preview';
import UserMemberApplicationConversion from './components/UserMembershipApplication/user-member-application-conversion';	
import { SettingsProvider } from './components/UserMembershipApplication/SettingsContext';
import UserLogin from './components/UserMembershipApplication/Authentication/login';
import UserForgotPassword from './components/UserMembershipApplication/Authentication/forgot-password';
import UserChangePassword from './components/UserMembershipApplication/Authentication/change-password';
import UserMembershipCertificateForMobile from './components/UserMembershipApplication/certificate/membership-certificate';
import FMASCertificateMobile from './components/UserMembershipApplication/certificate/fmas-certificate';
import InvoiceForMobile from './components/UserMembershipApplication/invoice/invoice';
import PaymentReceiptForMobile from './components/UserMembershipApplication/receipt/payment';
import UserMembershipCertificate from './components/UserMembershipApplication/user-member-application-certificate';
import KnownUserMemberApplication from './components/UserMembershipApplication/know-user-member-application';
class App extends Component {
	render() {
		const { themeColor, fontStyle, lightVersion, RtlVersion, offcanvas, miniSidebar, horizontalMenu, miniHover } = this.props;
		document.body.className = `${themeColor} ${fontStyle}${lightVersion ? ' light_version' : ''}${RtlVersion ? ' rtl' : ''}${offcanvas ? ' offcanvas-active' : ''}${horizontalMenu ? ' h-menu' : ''}${miniSidebar ? ' mini_sidebar' : ''}${miniHover ? ' mini_hover' : ''}`;
		
		const isAuthenticated = !!localStorage.getItem('loginUserId');

		return (
			<div ref={(leftSidebar) => (this.leftSidebar = leftSidebar)}>
				<Router>
					<Switch>
						<Route path={`${ROUTE_BASE_URL}/login`} component={Login} />
						<Route path={`${ROUTE_BASE_URL}/forgot-password`} component={ForgotPassword} />
						<Route path={`${ROUTE_BASE_URL}/change-password`} component={ChangePassword} />
						<Route path={`${ROUTE_BASE_URL}/user-login`} component={UserLogin} />
						<Route path={`${ROUTE_BASE_URL}/user-forgot-password`} component={UserForgotPassword} />
						<Route path={`${ROUTE_BASE_URL}/user-change-password`} component={UserChangePassword} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-track`} component={UserMemberApplicationLogin} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-not-found`} component={UserMemberApplicationNotFound} />
						<Route path={`${ROUTE_BASE_URL}/know-user-member-application/:slug`} component={KnownUserMemberApplication} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-status/:slug`} component={UserMemberApplicationTracking} />
						{/* <Route path={`${ROUTE_BASE_URL}/user-member-application-preview/:slug`} component={UserMemberApplicationPreview} /> */}
						<Route path={`${ROUTE_BASE_URL}/user-member-application-conversion/:slug`} component={UserMemberApplicationConversion} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-list`} component={UserMemberApplicationList} />				
			
						<Route
							path={`${ROUTE_BASE_URL}/user-member-application/:slug`}
							render={(props) => (
								<SettingsProvider>
									<UserMemberApplication {...props} />
								</SettingsProvider>
							)}
						/>
						<Route
							path={`${ROUTE_BASE_URL}/user-member-application-preview/:slug`}
							render={(props) => (
								<SettingsProvider>
									<UserMemberApplicationPreview {...props} />
								</SettingsProvider>
							)}
						/>
						<Route path={`${ROUTE_BASE_URL}/user-member-application-certificate-mobile/:slug`} component={UserMembershipCertificateForMobile} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-fmas-certificate-mobile/:slug`} component={FMASCertificateMobile} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-invoice/:slug`} component={InvoiceForMobile} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-receipt/:slug`} component={PaymentReceiptForMobile} />

						<Route path={`${ROUTE_BASE_URL}/user-member-application-payment/:slug`} component={UserMemberApplicationPayment} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-payment-failed/:slug`} component={UserMemberApplicationPaymentFailed} />
						<Route path={`${ROUTE_BASE_URL}/user-member-application-certificate/:slug`} component={UserMembershipCertificate} />
						<ProtectedRoute path={ROUTE_BASE_URL} component={Layout} isAuthenticated={isAuthenticated} />
						<Route component={NotFound} /> {/* Catch-all route for 404 */}
					</Switch>
				</Router>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	themeColor: state.settings.themeColor,
	fontStyle: state.settings.fontStyle,
	lightVersion: state.settings.lightVersion,
	RtlVersion: state.settings.RtlVersion,
	offcanvas: state.settings.offcanvas,
	horizontalMenu: state.settings.horizontalMenu,
	miniSidebar: state.settings.miniSidebar,
	miniHover: state.settings.miniHover,
});

export default connect(mapStateToProps)(App);
